import _ from "lodash";
import { computed, decorate, reaction, when } from "mobx";
import { RouterStore as MobxReactRouterStore } from "mobx-react-router";
import { FEED_PREFERENCES } from "utils/constants";

class RouterStore extends MobxReactRouterStore {
  constructor(videoSearchStore, basicSearchStore, pitsMetadataStore) {
    super();
    this.videoSearchStore = videoSearchStore;
    this.basicSearchStore = basicSearchStore;
    this.pitsMetadataStore = pitsMetadataStore;

    reaction(
      () => this.location,
      location => {
        const params = new URLSearchParams(location.search);
        if (this.isHomePage) {
          if (params.has("fp")) {
            const feedPreference = params.get("fp");
            if (
              _.map(FEED_PREFERENCES, o => o.value).includes(feedPreference)
            ) {
              this.videoSearchStore.feedPreference = feedPreference;
            }
          }

          const query = params.has("q")
            ? params.get("q")
            : 'GamePk > 0 AND IdType = "PLAY" Order By Timestamp DESC';
          this.videoSearchStore.setQuery(query);
          // Since the basicSearchStore.setClauses function requires the pitsMetadataStore
          // to be fully initialized, we'll wait until it is before running the command.
          when(
            () => this.pitsMetadataStore.isInitialized,
            () => {
              return this.basicSearchStore.setClauses(
                this.videoSearchStore.query,
                "STRUCTURED"
              );
            }
          );
          this.videoSearchStore.getPlays();
        }
      }
    );
  }

  get isHomePage() {
    return this.location.pathname === "/";
  }
}

decorate(RouterStore, {
  isHomePage: computed
});

export default RouterStore;



// WEBPACK FOOTER //
// ./src/stores/RouterStore.js